import React from 'react';
import { motion } from 'framer-motion';
import { Box, IconButton } from '@tempmee/react';
import { OutlineXIcon } from '@tempmee/react-icons';


export default function JobPostingPopup({ children, closeModal }) {
  return (
    <div className="modal" onClick={closeModal}>
      <motion.div
        onClick={(event) => event.stopPropagation()}
        className="modal_content"
        style={{ position: 'relative' }}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        {/*
         * `.modal_content` is a centered flex column, so the close button has to be
         * taken out of flow to sit in the corner — the wrapper anchors it against the
         * `position: relative` above.
         */}
        <Box className="absolute right-2 top-2">
          <IconButton
            type="button"
            appearance="default"
            color="secondary"
            size="small"
            aria-label="Close"
            data-testid="close-popup"
            data-cy="close-popup"
            onClick={closeModal}
            Icon={<OutlineXIcon />}
          />
        </Box>

        {children}
      </motion.div>
    </div>
  );
}
